import { Controller } from "@hotwired/stimulus"

// MS50 #3003 — CSP-safe field-template form behavior.
//
// Replaces the nonce-less inline <script> (blocked by the enforcing nonce CSP,
// #1222) that toggled the default-options section by field type. The default-
// choice add/remove is handled by the shared `nested-fields` controller.
export default class extends Controller {
  static targets = ["optionsSection"]

  // Field-type <select> changed → show the default-options section only for the
  // select / multi-select choice types.
  fieldTypeChanged(event) {
    if (!this.hasOptionsSectionTarget) return

    const type = event.target.value
    // #options-section renders with .d-none for non-choice types; show it only
    // for select / multi-select.
    this.optionsSectionTarget.classList.toggle(
      "d-none",
      ![ "select", "multi_select" ].includes(type)
    )
  }
}
